<app-obj-select-and-edit
  [doDelete]="doDelete"
  [editorTemplate]="optionEditor"
  [label]="'Switch Case'"
  [modifiedSelectedItem]="selectedKVPair?.value"
  [(orderedItems)]="objList"
  [(selectedKVPair)]="selectedKVPair"
  (duplicateClick)="duplicateClick()"
  (newClick)="newClick()"
>
  <ng-template #optionEditor let-index="id" let-item="item" let-kvPair>
    <p>Editing Option at Index: {{ this.selectedKVPair?.id }}</p>

    <app-vrc-editor-switch-case
      *ngIf="selectedKVPair?.value !== undefined"
      [(obj)]="selectedKVPair"
      (objChange)="updateAndEmit()"
    ></app-vrc-editor-switch-case>
  </ng-template>
</app-obj-select-and-edit>
